import { getLocaleFromUrl } from './locale-utils.js';

/**
 * Extracts the current route part from a pathname
 * EG: `/my-account/profile/subscriptions/12345`
 * will return a currentRoute of `profile/subscriptions/12345`
 *
 * EG: `/checkout/shipping`
 * will return a currentRoute of `shipping`
 *
 * For multilingual
 * EG: `/en_GB/book-appointment/type`
 * will return a currentRoute of `type`
 *
 * Also supports query params and hash fragments
 * EG: `/my-account/callback#access_token`
 * will return a currentRoute of `callback`
 *
 * EG: `/my-account/login?returnPath=path`
 * will return a currentRoute of `login`
 */ function extractCurrentRoute(path, locale) {
    // Path is a relative URL so we need to add a random base URL here to make URL() work
    const { pathname  } = new URL(path, 'https://not.used/');
    // Get the locale from url to avoid issues with locale parameter and url locale that are different)
    const urlLocale = getLocaleFromUrl(pathname);
    var ref;
    const parts = (ref = pathname.split('/')) !== null && ref !== void 0 ? ref : [];
    // If a site is multilingual and the url contains the locale (which it should)
    // we should skip one more part before we join the rest of the url parts together
    const skip = locale && (pathname.includes(`/${locale.replace('-', '_')}`) || urlLocale) ? 3 : 2;
    return parts.slice(skip).join('/');
}

export { extractCurrentRoute };
//# sourceMappingURL=extract-current-route.js.map
